module.exports = __webpack_public_path__ + "img/store_person_icon_green.e2096e94.svg";